export default {
  noData: 'Plus aucune donnée disponible',
  delConfirmTips: 'Êtes-vous sûr de vouloir supprimer les données sélectionnées ?',
  delSuccess: 'Supprimé avec succès',
  tips: 'Conseils',
  add: 'Ajouter',
  edit: 'Modifier',
  del: 'Supprimer',
  editSuccess: 'Modifié avec succès',
  activeAccount: 'Activer le compte',
  mailActiveSuccess: 'Activation du compte réussie',
  back: 'Retour',
  goLogin: 'Aller à la connexion',
  email: 'E-mail',
  emailSendSuccess: 'E-mail envoyé avec succès',
  paySuccess: 'Paiement réussi',
  action: 'Action',
  logoutSuccess: 'Déconnexion réussie',
  plsUpload: 'Veuillez télécharger',
  upload: 'Télécharger',
  file: 'Fichier',
  uploadFail: 'Échec du téléchargement',
  uploadSuccess: 'Téléchargement réussi',
  pay: 'Payer',
  day: 'Jour',
  servePrice: 'Frais de service',
  skillServePrice: 'Frais de service technique',
  unitMonth: 'Mois',
  num: 'Quantité',
  photo: 'Photo',
  product: 'Produit',
  sizeHaveUnit: 'Taille (cm)',
  weightHaveUnit: 'Poids (g)',
  fee: 'Frais',
  free: 'Gratuit',
  submitTime: 'Heure de soumission',
  weight: 'Poids',
  cancelReason: "Motif d'annulation",
  submitPackage: 'Soumettre le colis',
  submitSuccess: 'Soumission réussie',
  price: 'Prix',
  status: 'Statut',
  noProduct: 'Aucun produit',
  backEdit: 'Retour à la modification',
  errorHint: "Erreur d'interface, veuillez réessayer",
  reload: 'Actualiser',
  reloadPageTips:
    'Vous avez changé de compte. Veuillez actualiser la page pour obtenir les informations mises à jour.',
  cancel: 'Annuler',
  noMsg: 'Aucune information',
  totalAmount: 'Montant total',
  see: 'Voir',
  confirm: 'Confirmer',
  send: 'Envoyer',
  nowNoInfo: 'Aucune information pour le moment',
  genderEnum: {
    0: 'Homme',
    1: 'Femme',
  },
  goEmailActiveTips: 'Veuillez consulter votre e-mail pour activer votre compte !',
  holder: {
    inputRemark: 'Veuillez saisir des remarques',
    inputExplainCancelReason: "Veuillez expliquer le motif de l'annulation",
    inputAddAddress: "Veuillez ajouter l'adresse de livraison",
    inputMsg: 'Veuillez saisir un message',
  },
  acceptMsg:
    "Ce site web stocke des cookies sur votre ordinateur pour vous offrir une meilleure expérience. Consultez notre politique de confidentialité pour plus d'informations.",
  accept: 'Accepter',
  refuse: 'Refuser',
  notice: 'Avis',
  noticeMsg: 'Nouvelle ligne logistique, réduction de prix de 10%',
  english: 'Anglais',
  spanish: 'Espagnol',
  french: 'Français',
  chinese: 'Chinois',
  copySuccess: 'Copie réussie',
  copyError: 'Échec de la copie',
  noAgainShow: 'Ne plus afficher',
  download: 'Télécharger',
  downloadSuccess: 'Téléchargement réussi',
  uploadImgTips: 'Veuillez télécharger des fichiers JPG/PNG/WEBP/JPEG',
  noCheckAboutAgree: "Non coché : J'accepte les conditions d'utilisation",
  country: 'Pays',
  collectSuccess: 'Collecte réussie !',
  cancelCollectSuccess: 'Suppression de la collecte réussie !',
  formatError: 'Erreur de format, par exemple, {formatStr}',
  volume: 'Volume (cm³)',
  notRequired: 'Non requis',
  productSaleCount: 'Ventes',
  searchPlaceholder: 'Veuillez saisir le contenu de recherche',
  THEME_MODE: 'Mode de thème',
  FOLLOW_SYSTEM: 'Suivre le système',
  DAY_MODE: 'Mode jour',
  NIGHT_MODE: 'Mode nuit',
}
